import styled from 'styled-components';

export const WhyContainer = styled.article`
  position: relative;
`;

export const WhyDropdown = styled.ul`
  position: absolute;
  z-index: 10;
  right: 0;
  bottom: 0;
  transform: translateY(100%);

  width: 100%;
  padding: 20px 15px;

  background-color: ${({ theme }) => theme.white};
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  overflow: hidden;

  opacity: 0;
  user-select: none;
  pointer-events: none;

  transition: opacity 0.3s;
`;

export const WhyHeading = styled.p`
  margin: 15px 0;
  padding: 0;

  font-size: 14px;
  line-height: 1;
  color: ${({ theme }) => theme.blue};
  text-align: center;

  cursor: pointer;

  &:hover + ${WhyDropdown} {
    opacity: 1;
  }

  &::before {
    content: "?";

    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
    padding: 2px 5px;

    font-size: 12px;
    line-height: 1;

    background-color: ${({ theme }) => theme.lightGray};
    border-radius: 50%;
  }
`;

export const WhyItem = styled.li`
  display: flex;
  align-items: center;

  font-size: 12px;

  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;
